<!--
  ~ Copyright (c) Worldline 2023.
  -->

<div id="mainCertificatePopup" class="ngdialog-content">

    <div class="modal-body">
        <table>
            <tbody>
            <tr>
                <td class="tableTitle">{{'certificatePopup.subject' | translate}}</td>
                <td class="tableData" title="{{activeSignature.name}}">{{activeSignature.name}}</td>

            </tr>
            <tr>
                <td class="tableTitle">{{'certificatePopup.issuer' | translate}}</td>
                <td class="tableData" title="{{activeSignature.issuerDn}}">{{activeSignature.issuerDn}}</td>
            </tr>
            <tr>
                <td class="tableTitle">{{'certificatePopup.creationDate' | translate}}</td>
                <td class="tableData">{{activeSignature.creationDate}}</td>
            </tr>
            <tr>
                <td class="tableTitle">{{'certificatePopup.expirationDate' | translate}}</td>
                <td class="tableData">{{activeSignature.expirationDate}}</td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="modal-footer">
        <button class="certificateClose" (click)="activeModal.close('Save click')">{{'close' | translate}}</button>
    </div>
</div>
